// extracted by mini-css-extract-plugin
export var displayNone = "_q7-6";
export var imgContainer = "_q7-2";
export var overflowHidden = "_q7-3";
export var productInfoCardButtonContainer = "_q7-5";
export var productTitleText = "_q7-4";
export var rightArrow = "_q7-1";
export var rightArrowContainer = "_q7-0";